import React, { useContext } from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import TextLink from 'components/Luxkit/TextLink'
import GeoContext from 'contexts/geoContext'

function FlightDealConditions() {
  const { currentRegionCode } = useContext(GeoContext)
  const termsAndConditionsURL = `https://luxuryescapes.com/${currentRegionCode.toLocaleLowerCase()}/flights-policies`

  return (
    <BodyText variant="small" italics>
      All prices displayed are subject to availability and can be withdrawn or varied without notice.{' '}
      Flights might be subject to a booking fee at the time of purchase which can be found in our terms and conditions.{' '}
      Full terms and conditions can be found here -{' '}
      <TextLink
        variant="black"
        weight="regular"
        href={termsAndConditionsURL}
        rel="noreferrer noopener"
        target="_blank"
      >
        {termsAndConditionsURL}
      </TextLink>
    </BodyText>
  )
}

export default FlightDealConditions
